import { render } from "./Authorized.vue?vue&type=template&id=773dac58&scoped=true"
import script from "./Authorized.vue?vue&type=script&lang=js"
export * from "./Authorized.vue?vue&type=script&lang=js"

import "./Authorized.vue?vue&type=style&index=0&id=773dac58&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773dac58"]])

export default __exports__